// A trilha é da rota-pai (`admin.audit-log.tsx`), porque ela continua desenhada embaixo
// quando a linha abre no drawer (`spec/24` §1 decisão 5). Esta rota-índice existe só para
// `/admin/audit-log` ser um destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/audit-log/')({ component: () => null });
